<template>
  <v-card class="mt-6">
    <v-card-title>
      Alerta Diárias automáticas
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-switch
            :value="config.daily_alert_enabled"
            color="primary"
            inset
            label="Ativar"
            @change="updateField('daily_alert_enabled', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.daily_alert_time"
            type="time"
            outlined
            :error="dailyAlertInput.error"
            :error-messages="dailyAlertInput.message"
            :disabled="!config.daily_alert_enabled"
            label="Horário"
            @input="updateField('daily_alert_time', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.daily_alert_interval"
            type="number"
            outlined
            :error="dailyAlertIntervalInput.error"
            :error-messages="dailyAlertIntervalInput.message"
            :disabled="!config.daily_alert_enabled"
            label="Intervalo entre alertas (min)"
            @input="updateField('daily_alert_interval', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DailyAlertSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
    dailyAlertInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
    dailyAlertIntervalInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
